require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-locations-larreynaga.json") })
        }
      }, "path---en-locations-larreynaga");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-locations-larreynaga!./.cache/json/en-locations-larreynaga.json
// module id = 1055
// module chunks = 231608221292675